import ko from '@tko/build.knockout';

ko.utils.hasError = function(observable) {
  return observable.hasError && Object.values(observable.hasError).some(value => ko.unwrap(value));
};

ko.utils.validationMessage = function(observable) {
  if (observable.validationMessage) {
    return Object.entries(observable.validationMessage)
      .map(([key, value]) => ko.unwrap(value))
      .join(" ");  
  }
  return '';
};

ko.extenders.regex = function(target, options) {
  // 1. Core tracking fields
  target.hasError = target.hasError || {};
  target.validationMessage = target.validationMessage || {};
  target.hasError.regex = ko.observable(false);
  target.validationMessage.regex = ko.observable("");

  // 2. Unpack options (handles objects or raw regex)
  const pattern = options.pattern || options;
  const message = options.message || "Invalid format.";

  function validate(value) {
    // Allow empty values to pass (let a 'required' extender handle emptiness)
    if (value === undefined || value === null || value === "") {
      target.hasError.regex(false);
      return;
    }

    const isValid = pattern.test(String(value));
    target.hasError.regex(!isValid);
    target.validationMessage.regex(isValid ? "" : message);
  }

  // 3. Initial check and event subscription
  validate(target());
  target.subscribe(validate);

  return target;
};

ko.extenders.required = function(target, options) {
  // 1. Core tracking fields
  target.hasError = target.hasError || {};
  target.validationMessage = target.validationMessage || {};
  target.hasError.required = ko.observable(false);
  target.validationMessage.required = ko.observable("");

  // 2. Unpack options (handles objects or raw regex)
  const message =  "This field is required.";
  const required = options || true;

  function validate(val) {
    var result = true;
    var testVal;

    let currentRequired = ko.unwrap(required);
    
    if (val === undefined || val === null) {
      result = !currentRequired;
    } else {


      testVal = val;
      if (typeof (val) === 'string') {
        if (String.prototype.trim) {
          testVal = val.trim();
        } else {
          testVal = val.replace(/^\s+|\s+$/g, '');
        }
      }

      if (!currentRequired) {// if they passed: { required: false }, then don't require this
        result = true;
      } else {
        result = ((testVal + '').length > 0);
      }
    }

    target.hasError.required(!result);
    target.validationMessage.required(result ? "" : message);
  }

  // 3. Initial check and event subscription
  validate(target());
  target.subscribe(validate);

  return target;
};
